import styled from "styled-components";
import {useParams} from "react-router-dom";
import {useMemo, useState} from "react";
import {MbjLoading, MbjModal2, useModal} from "@mbj-front-monorepo/ui";
import {
    components,
    useGetResultsSearchParticulierBySearch,
    useGetResultsSearchReclassementBySearch
} from "@mbj-front-monorepo/data-access";
import {ResultParticulierCard} from "../components/ResultParticulierCard";
import {Compare} from "../../../../../../components/Comparateur/ComparaisonRef/Compare";
import {ResultReclassementCard} from "../components/ResultReclassementCard";

interface ResultsReclassementsCtrlProps{
    className?:string;
}

const ResultsReclassementsCtrl = (props:ResultsReclassementsCtrlProps)=>{
    const {id} = useParams();
    const [min, setMin] = useState(0);
    const [max, setMax] = useState(1);
    const {isShowing, toggle} = useModal();
    const ResultsQuery = useGetResultsSearchReclassementBySearch(id ? parseInt(id) : 0)
    const [resultReclCurr, setResultReclCurr] = useState<components["schemas"]["ResultsSearchReclassement-resultssearchreclassement.read_searchs.read_read.Member_read.UserMetier_read.Metier_statutresult.read_read.MemberMetierReclassement_read.ReclassementEmployees_read.Employee.simple"]|null>(null)
    const listResult = useMemo(()=>{
        if(!ResultsQuery.data){
            return [];
        } else {
            return ResultsQuery.data.filter(r=>{
                const CondMin = r.score && r.score >= min;
                const CondMax = r.score && r.score <= max;
                return CondMax && CondMin;
            })
        }
    }, [ResultsQuery.data, min, max])
    const ClickOnCompareRecl = (result:components["schemas"]["ResultsSearchReclassement-resultssearchreclassement.read_searchs.read_read.Member_read.UserMetier_read.Metier_statutresult.read_read.MemberMetierReclassement_read.ReclassementEmployees_read.Employee.simple"])=>{
        console.log('click !!');
        setResultReclCurr(result);
        toggle();
    }
    return (
        <div className={"result_recl "+props.className}>
            <div className={"wrap_results"}>
                {ResultsQuery.isLoading ? (<MbjLoading/>) : ResultsQuery.isError ? 'Error data' :
                    (
                        <div className={"wrap_result"}>
                            {listResult.map((item)=>(
                                <ResultReclassementCard key={`r${item.id}`} Search={item} clickCompare={ClickOnCompareRecl}/>
                            ))}
                        </div>
                    )
                }
            </div>
            <MbjModal2 open={isShowing} closeMe={toggle} titre={"Comparaison"}>
                <Compare
                    SearchEmp={undefined}
                    SearchPart={undefined}
                    SearchRecl={resultReclCurr||undefined}
                />
            </MbjModal2>
        </div>
    )
}

const ResultsReclassements = styled(ResultsReclassementsCtrl)`
  padding: 2% 1%;
  .wrap_result{
    display: flex;
    flex-wrap: wrap;
  }
`


export default ResultsReclassements;
